export function deeplyDeleteUndefined<T>(object: T): T {
	const result: Record<string, unknown> = {};

	if (Array.isArray(object)) {
		return object.map(deeplyDeleteUndefined).filter((value) => value !== undefined) as T;
	}

	if (object !== null && object !== undefined && typeof object === "object") {
		for (const [key, value] of Object.entries(object)) {
			const obj = deeplyDeleteUndefined(value as Record<string, unknown>) as T | undefined;
			if (obj !== undefined) {
				result[key] = obj;
			}
		}

		return result as T;
	}

	return (object ?? undefined) as T;
}
